'use client';

import { CategoryPreferences } from '@segment/consent-manager/types/types';
import { PostHog } from 'posthog-js/dist/module.slim';

import { getFeatureFlagsProperties } from '@pflegia/feature-flags/utils/helpers/get-feature-flag-properties';

import { segmentService } from '../application/analytics/segment.service';

export const decidePosthogCapture = (phInstance: PostHog, cookiesSettings?: CategoryPreferences, { sendPageView = true } = {}) => {
  // we need to opt in or out of capturing based on the user consent settings
  if (cookiesSettings?.marketingAndAnalytics && phInstance.has_opted_out_capturing()) {
    phInstance.opt_in_capturing();
    phInstance._start_queue_if_opted_in();
    phInstance.reloadFeatureFlags();
    if (sendPageView) {
      phInstance.onFeatureFlags(() => {
        segmentService.page(undefined, {
          ...getFeatureFlagsProperties(),
        });
      });
    }
  }
  if (cookiesSettings?.marketingAndAnalytics === false) {
    phInstance.opt_out_capturing();
  }
};
